import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "document",
    standalone: false
})
export class DocumentPipe implements PipeTransform {
  transform(document = "", obfuscate = false) {
    if (document) {
       let newDocument = document?.toString().replace(/\D/g, "");

      switch (document.length) {
        case 4:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 5:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 6:
          newDocument = newDocument.replace(/(\d+)(\d{3})/, "$1.$2");
          break;
        case 7:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 8:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 9:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})/, "$1.$2.$3");
          break;
        case 10:
          newDocument = newDocument.replace(/(\d+)(\d{3})(\d{3})(\d)/, "$1.$2.$3-$4");
          break;
        case 11:
          newDocument = newDocument.replace(
            /(\d+)(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4",
          );
          break;
        case 12:
          newDocument = newDocument.replace(
            /(\d+)(\d{3})(\d{3})(\d{4})/,
            "$1.$2.$3/$4",
          );
          break;
        case 13:
          newDocument = newDocument.replace(
            /(\d+)(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5",
          );
          break;
        case 14:
          newDocument = newDocument.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/,
            "$1.$2.$3/$4-$5",
          );
          break;
      }

      if (obfuscate) {
        newDocument = newDocument.replace(/(\d+\.\d+\.)\d{3}-(\d{2})/, "$1***-**"); // NOSONAR
      }

      return newDocument;
    }

    return document;
  }
}
